import { RESOURCE_MARKS, type ResourceMarkKey } from '../lib/resourceMarks';

/**
 * Square mark for an external site resource. Renders the resource's PNG when
 * one is configured and falls back to its two-letter abbreviation otherwise
 * (or if the image fails to load). Decorative: the adjacent title names the
 * resource, so the mark is hidden from assistive tech.
 */
export function ResourceMark({
  kind,
  size = 'md',
}: {
  kind: ResourceMarkKey;
  /** `md` is the 32px panel tile; `sm` is the 16px inline chip mark. */
  size?: 'sm' | 'md';
}) {
  const spec = RESOURCE_MARKS[kind];
  const box = size === 'sm' ? 'h-4 w-4 rounded-[3px] text-[7px]' : 'h-8 w-8 rounded-sm text-[10px]';
  return (
    <span
      aria-hidden="true"
      data-resource-mark={kind}
      className={`flex shrink-0 items-center justify-center overflow-hidden bg-surface-3 font-bold tracking-wide text-primary ${box}`}
    >
      {spec.icon && (
        <img
          src={spec.icon}
          alt=""
          className="h-full w-full object-cover"
          onError={(event) => {
            const el = event.currentTarget;
            el.style.display = 'none';
            const fallback = el.nextElementSibling;
            if (fallback instanceof HTMLElement) fallback.hidden = false;
          }}
        />
      )}
      <span hidden={!!spec.icon}>{spec.abbr}</span>
    </span>
  );
}
